import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`A line item tax rate can be set if the cart has the `}<inlineCode parentName="p">{`External`}</inlineCode>{` `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#taxmode"
        }}>{`TaxMode`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setLineItemTaxRate"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`lineItemId`}</inlineCode>{` - String`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`externalTaxRate`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#externaltaxratedraft"
          }}>{`ExternalTaxRateDraft`}</a>{` - Optional`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      